module.exports = __webpack_public_path__ + "static/media/mile3.b693d5e6.png";